import type { Ref } from 'vue'
import { ref } from 'vue'
import { StringUtils } from '../utils/string.utils'

export interface UseCopyToClipboard {
  copyToClipboardIcon: Ref<CopyToClipboardIconEnum>
  copyToClipboard: (value: string) => Promise<void>
}

export enum CopyToClipboardIconEnum {
  DEFAULT = 'clone',
  SUCCESS = 'accept',
  ERROR = 'close',
}

export function useCopyToClipboard(): UseCopyToClipboard {
  const copyToClipboardIcon = ref<CopyToClipboardIconEnum>(CopyToClipboardIconEnum.DEFAULT)

  const copyToClipboard = async (value: string): Promise<void> => {
    try {
      await StringUtils.copyToClipboard(value)
      copyToClipboardIcon.value = CopyToClipboardIconEnum.SUCCESS
    } catch (error) {
      copyToClipboardIcon.value = CopyToClipboardIconEnum.ERROR
      throw error
    } finally {
      setTimeout(() => {
        copyToClipboardIcon.value = CopyToClipboardIconEnum.DEFAULT
      }, 1000)
    }
  }

  return {
    copyToClipboardIcon,
    copyToClipboard,
  }
}
